import { Orientation, PaperFormat } from "../types/pdf-generator";

/**
 * Configurer la taille de page
 */
export const pageSizes: Record<PaperFormat, [number, number]> = {
  A4: [595.28, 841.89],
  A3: [841.89, 1190.57],
  "US-Letter": [612, 792],
  "US-Legal": [612, 1008],
};

/**
 * Générer le format de page
 */
export const generatePageFormat = (
  paperFormat: PaperFormat,
  orientation?: Orientation
): [number, number] => {
  const [pageWidth, pageHeight] = pageSizes[paperFormat] || pageSizes.A4;
  if (orientation === "landscape") {
    return [pageHeight, pageWidth];
  }
  return [pageWidth, pageHeight];
};
